import { ResponseDataGet } from "../../../models/responseDataGet";
import { ResponseDataTest } from "../../../models/responseDataTest";
import { agroApi } from "../api";
import { EntFertilizerUsage } from "../../../models/chemicalization/fertilizerUsage";
import { EntFertilizerUsageFilter } from "../../../models/filters/fertilizerUsageFilter";
import { BlobResponse } from "../../../models/report";
import { EntReportPesticidesFilter } from "../../../models/filters/pesticidesFilter";
import { Paths } from "../../../paths";


export const fertilizerUsageApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({

    getFertilizerUsageList: builder.query<ResponseDataGet<EntFertilizerUsage>, EntFertilizerUsageFilter>({
      query: (filter) => ({
        url: `${Paths.chemicalization.fertilizer_usage}/get-all`,
        method: "POST",
        body: JSON.stringify(filter),
      }),
    }),

    getFertilizerUsageById: builder.query<ResponseDataTest<EntFertilizerUsage>, number>({
      query: (id) => ({
        url: `${Paths.chemicalization.fertilizer_usage}/${ id }`,
        method: 'GET'
      })
    }),
    addFertilizerUsage: builder.mutation<ResponseDataTest<EntFertilizerUsage>, EntFertilizerUsage>({
      query: (body) => ({
        url: `${Paths.chemicalization.fertilizer_usage}`,
        method: "POST",
        body: JSON.stringify(body)
      }),
    }),
    editFertilizerUsage: builder.mutation<ResponseDataTest<EntFertilizerUsage>, EntFertilizerUsage>({
      query: (body,) => ({
        url: `${Paths.chemicalization.fertilizer_usage}`,
        method: 'PUT',
        body: JSON.stringify(body),
      }),
    }),
    deleteFertilizerUsage: builder.mutation<ResponseDataTest<EntFertilizerUsage>, number>({
      query: (id) => ({
        url: `${Paths.chemicalization.fertilizer_usage}/${ id }`,
        method: 'DELETE',
      }),
    }),
    reportFertilizerUsage: builder.mutation<BlobResponse, EntReportPesticidesFilter>({
      query: (payload) => {
        const { periodStart, periodEnd, language } = payload;

        return {
          url: `/departments/chemicalization/report/fertilizer-usage`,
          method: "POST",
          params: {
            periodStart,
            periodEnd,
            language
          },
          body: JSON.stringify(payload),
          responseHandler: (response) => response.blob(),
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const {
  useAddFertilizerUsageMutation,
  useDeleteFertilizerUsageMutation,
  useEditFertilizerUsageMutation,
  useLazyGetFertilizerUsageListQuery,
  useReportFertilizerUsageMutation
} = fertilizerUsageApi;
